"use strict";
require('documenteditor/documenteditor');
require('common/directives/paginationDirective');
require('common/filters');
var urls = require('common/urls');
var editCtrl = require('work/controllers/editCtrl');
var indexCtrl = require('work/controllers/indexCtrl');
var workListCtrl = require('common/controllers/workListCtrl');
var confirmModalCtrl = require('work/controllers/confirmModalCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('work', ['documenteditor', 'paginationDirective', 'templates', 'ngFlash', 'ui.bootstrap', 'filters']);
app.controller('indexCtrl', ['$scope', '$rootScope', '$http', '$timeout', 'urls', 'Flash', 'permissions', indexCtrl]);
app.controller('editCtrl', ['$scope', '$rootScope', '$http', 'urls', 'id', 'values', 'schema', 'dianrs', 'Flash', 'permissions', '$uibModal', 'previousId', 'nextId', 'rdfUri', editCtrl]);
app.controller('workListCtrl', ['$scope', '$rootScope', '$http', '$timeout', workListCtrl]);
app.controller('confirmModalCtrl', ['$scope', '$uibModalInstance', '$q', '$http', '$timeout', 'commentsParams', confirmModalCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
app.value('urls', urls);
module.exports = app;
